module.exports = __webpack_public_path__ + "img/battleingBg.55fd82b0.png";